<template>
    <modal v-if="visible" modal-container-class="w-1/2 relative">
        <div class="absolute top-0 right-0" slot="absolute">
            <button @click="closeModal">
                <img class="w-6 m-4" src="/svg/close.svg" alt="close" />
            </button>
        </div>
        <div slot="header">
            <h2 class="text-lg font-bold">Neuspješna sinkronizacija za {{ date }}</h2>
        </div>
        <div slot="body">
            <div v-if="failedSyncs.length > 0">
                <table class="w-full text-left border-collapse">
                    <thead>
                    <tr>
                        <th class="border-b py-2">ID Projekta</th>
                        <th class="border-b py-2">Poruka</th>
                        <th class="border-b py-2">Ukupni sati</th>
                        <th class="border-b py-2">Ukupna cijena</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="sync in failedSyncs" :key="sync.id">
                        <td class="py-2">{{ sync.details.project_id || '' }}</td>
                        <td class="py-2">{{ sync.message }}</td>
                        <td class="py-2">{{ sync.details.total_hours || '' }}</td>
                        <td class="py-2">{{ sync.details.total_price || '' }}</td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <div v-else>
                <p class="text-gray-500">Nema neuspješnih syncova za odabrani datum.</p>
            </div>
        </div>
        <div slot="footer">
            <button class="btn secondary" @click="$emit('close')">Zatvori</button>
        </div>
    </modal>
</template>

<script>
import Modal from "./Modal";
export default {
    components: {
        Modal,
    },
    props: {
        visible: {
            type: Boolean,
            required: true,
        },
        date: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            failedSyncs: [],
        };
    },
    watch: {
        visible(newValue) {
            if (newValue) {
                this.fetchFailedSyncs();
            }
        },
    },
    methods: {
        fetchFailedSyncs() {
            axios
                .get('/odoo-sync/failed', { params: { sync_date: this.date } })
                .then((response) => {
                    this.failedSyncs = response.data;
                })
                .catch((error) => {
                    console.error('Error fetching failed syncs:', error);
                });
        },
        closeModal() {
            this.$emit('close');
        },
    },
};
</script>
